import { useProviderSession } from './previewSession'

const ORG_TYPE_LABELS: Record<string, string> = {
    dd_board: 'Developmental disabilities board',
    early_intervention: 'Early intervention program',
    clinic: 'Clinic',
    school: 'School',
    nonprofit: 'Nonprofit',
    other: 'Other',
}

// Read-only in v1: organizations are provisioned by BrightPath (org profile,
// seat quota), so this screen shows the current configuration and points
// changes at the support contact. Team management lives on /team.
export default function ProviderSettings() {
    const session = useProviderSession()

    const org = session?.organization

    return (
        <div className='max-w-4xl mx-auto px-4 sm:px-6 py-8'>
            <div className='mb-6'>
                <h1 className='text-2xl sm:text-3xl font-bold text-neutral-900'>Settings</h1>
                <p className='text-sm text-neutral-600 mt-1'>Your organization configuration.</p>
            </div>

            {/* Org info */}
            <Section title='Organization'>
                <Field label='Organization name' value={org?.name} />
                <Field label='Display name shown to clients' value={org?.displayName} />
                <Field label='Type' value={ORG_TYPE_LABELS[org?.type ?? ''] ?? org?.type} />
                <Field label='Primary contact' value={org?.contactName} />
                <Field label='Contact email' value={org?.contactEmail} />
                <Field label='Seat quota' value={org ? `${org.seatQuota} client licenses` : undefined} />
            </Section>

            {/* Account */}
            <Section title='Account'>
                <p className='text-sm text-neutral-600'>
                    Organization profile changes, seat quota adjustments, and account questions are handled by
                    BrightPath. Contact <span className='text-brand-700'>support@brightpathforautism.com</span>.
                </p>
            </Section>
        </div>
    )
}

function Section({ title, children }: { title: string; children: React.ReactNode }) {
    return (
        <div className='bg-white border border-neutral-200 rounded-2xl p-6 mb-6'>
            <h2 className='text-lg font-semibold text-neutral-900 mb-4'>{title}</h2>
            {children}
        </div>
    )
}

function Field({ label, value }: { label: string; value?: string | null }) {
    return (
        <div className='py-2'>
            <div className='text-xs uppercase tracking-wider text-neutral-500 mb-1'>{label}</div>
            <div className='text-sm text-neutral-900'>{value || 'Not set'}</div>
        </div>
    )
}
